import { createAction } from 'typesafe-actions';
import { IPumpingStationFlowmeterPulse } from '../../../../@types/model/masterData/pumpingStation/flowmeterPulse';

export default class MasterDataPumpingStationFlowmeterPulseActions {
    public static readonly set = createAction('MASTER_DATA_SET_PUMPING_STATION_FLOWMETER_PULSE', resolve => (pumps : Array<IPumpingStationFlowmeterPulse>) => resolve(pumps));
    public static readonly setLoading = createAction('MASTER_DATA_SET_PUMPING_STATION_FLOWMETER_PULSE_LOADING', resolve => (isLoading : boolean) => resolve(isLoading));
}